import { useQuery } from '@tanstack/react-query';
import { auth } from '../firebase/firebaseConfig';
import { loadPrimaryRoleId } from '../services/roleAssignmentService';

export const PRIMARY_ROLE_ID_QUERY_KEY = 'primaryRoleId';

/**
 * Lightweight primary role id — single `users/{uid}` getDoc, not the full profile.
 * @param {string|null|undefined} userId
 */
export function usePrimaryRoleId(userId) {
  const uid =
    userId === undefined
      ? auth.currentUser?.uid ?? null
      : userId;

  return useQuery({
    queryKey: [PRIMARY_ROLE_ID_QUERY_KEY, uid],
    queryFn: async () => {
      if (!uid) {
        throw new Error('No authenticated user');
      }
      return loadPrimaryRoleId(uid);
    },
    enabled: !!uid,
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });
}
